/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {WhmcsClient, WhmcsClientDetails} from '../models/whmcs-client.model';
import {WhmcsStats} from '../models/whmcs-stats.model';
import {StripePayout} from '../models/stripe.model';
import {VultrInstance} from '../models/vultr-instance';
import {VultrSnapshot} from '../models/vultr-snapshot';

@Injectable({providedIn: 'root'})
export class VultrService {
	getInstances(): Observable<VultrInstance[]> {
		return this.http.post(
			API_ENDPOINTS.SERVERS.VULTR_GET_INSTANCES,
			{ }
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toVultrInstancesArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	getSnapshots(): Observable<VultrSnapshot[]> {
		return this.http.post(
			API_ENDPOINTS.SERVERS.VULTR_GET_SNAPSHOTS,
			{ }
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toVultrSnapshotsArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	createSnapshot(instanceId: string, label: string): Observable<any> {
		return this.http.post(
			API_ENDPOINTS.SERVERS.VULTR_CREATE_SNAPSHOT,
			{
				instance_id: instanceId,
				description: label
			}
		);
	}

	private toVultrInstancesArray(data): VultrInstance[] {
		const instances: VultrInstance[] = [];
		for (const item of data) {
			instances.push(
				new VultrInstance(
					StringFunctions.emptyToNull(item.id),
					StringFunctions.emptyToNull(item.os),
					parseInt(item.ram, 10),
					parseInt(item.disk, 10),
					StringFunctions.emptyToNull(item.main_ip),
					StringFunctions.emptyToNull(item.region),
					StringFunctions.emptyToNull(item.status),
					StringFunctions.emptyToNull(item.power_status),
					StringFunctions.emptyToNull(item.server_status),
					StringFunctions.emptyToNull(item.label),
					StringFunctions.emptyToNull(item.kvm),
				)
			);
		}
		return instances;
	}

	private toVultrSnapshotsArray(data): VultrSnapshot[] {
		const snapshots: VultrSnapshot[] = [];
		for (const item of data) {
			snapshots.push(
				new VultrSnapshot(
					StringFunctions.emptyToNull(item.id),
					StringFunctions.emptyToNull(item.date_created),
					StringFunctions.emptyToNull(item.description),
					StringFunctions.emptyToNull(item.status)
				)
			);
		}
		return snapshots;
	}

	constructor(private http: HttpClient) { }
}
